module.exports = "https://web-assets.ifttt.com/packs/media/marketing/do_ios-d35e38e4.png";